import { Chip, StatusGlyph } from "@outpave/ds";
import PaymentStatus from "enums/PaymentStatus";
import WorkflowRequestStatus from "enums/WorkflowRequestStatus";
import { useTranslation } from "react-i18next";
import {
  paymentDisplayStatus,
  paymentStatusLabelKey,
  paymentStatusTone,
} from "utils/payments/paymentStatus";

interface RenderPaymentStatusProps {
  paymentStatus: PaymentStatus | string;
  workflowStatus?: WorkflowRequestStatus;
}

/**
 * One payment status pill for every surface that draws one, over the shared
 * label and tone maps in `payments/paymentStatus.ts`.
 */
export const RenderPaymentStatus: React.FC<RenderPaymentStatusProps> = ({
  paymentStatus,
  workflowStatus,
}) => {
  const { t } = useTranslation();

  const displayStatus = paymentDisplayStatus(paymentStatus, workflowStatus);
  const labelKey = paymentStatusLabelKey(displayStatus);
  const tone = paymentStatusTone(displayStatus);

  // StatusGlyph is looked up by the untranslated label, so the glyph is right
  // in every locale while the label renders translated. An unknown status gets
  // none: the tone fallback draws "deactivated", which reads as a real state.
  return (
    <Chip
      tone={tone}
      size="sm"
      leading={
        displayStatus ? (
          <StatusGlyph status={labelKey} tone={tone} />
        ) : undefined
      }
    >
      {t(labelKey)}
    </Chip>
  );
};
